import styled from 'styled-components';
import { palette } from 'styled-tools';

import { FontSizes, FontWeights, maxWidth, minWidth, Text, units } from '@calm-web/design-system';

export const Header = styled(Text).attrs({
	el: 'h2',
	size: FontSizes.base,
	weight: FontWeights.Demi,
	noMargin: true,
})`
	display: none;

	${minWidth('desktop')} {
		display: block;
		text-align: center;
		max-width: 350px;
		margin-top: ${units(3)};
		padding: 0 ${units(3)};
	}
`;

export const Container = styled.div`
	background-color: ${palette('white')};
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border-radius: 20px;
	height: 100%;

	${minWidth('desktop')} {
		min-width: 100%;
		max-width: 460px;
		margin: 0;
		padding-bottom: ${units(1)};
	}
`;

export const QrCodeContainer = styled.div`
	display: none;

	${minWidth('desktop')} {
		display: block;
	}
`;

export const QrCodeAndStoreButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	padding-bottom: ${units(1)};
	padding-top: ${units(1)};
`;

export const StoreButtonContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	padding: ${units(2)};

	${minWidth('desktop')} {
		display: flex;
		flex-direction: column;
		padding: 0 ${units(2)};
	}
`;

export const ButtonColumn = styled.div`
	display: flex;

	${maxWidth('desktop')} {
		margin-left: 1rem;
	}

	${minWidth('desktop')} {
		margin-top: 1rem;
	}
`;
